module.exports = __webpack_public_path__ + "img/2024080214495736bbZ.1df72a38.png";